// assets/cc-animations.js
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Add reveal class to legacy section-level containers
  var sectionSelectors = [
    '.cc-section',
    '.cc-page-header',
    '.cc-collection-header',
    '.cc-about__hero',
    '.cc-contact',
    '.cc-bookings'
  ].join(',');
  document.querySelectorAll(sectionSelectors).forEach(function (el) {
    el.classList.add('cc-reveal');
  });

  // Observe ALL .cc-reveal elements (sections + per-item stagger via --cc-delay)
  var els = document.querySelectorAll('.cc-reveal');
  if (!els.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('cc-is-visible');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.08 }
  );
  els.forEach(function (el) { io.observe(el); });

  // FAQ accordion — event delegation (replaces inline onclick in cc-faq-teaser.liquid)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cc-faq-item__btn');
    if (!btn) return;
    var item = btn.closest('.cc-faq-item');
    if (!item) return;
    var open = item.classList.toggle('cc-faq-item--open');
    btn.setAttribute('aria-expanded', String(open));
  });
})();
